// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/takeoff-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/takeoff-technique/takeoff-technique.js';

mount([g0]);
